import React from "react";
import Proptypes from "prop-types";
import {
	ModalContainer,
	CareerTrackModalWrapper,
	ModalHeading,
	CardsWrapper,
	CourseCard,
	CardContainer,
	CardHeader,
	Heading,
	Content,
	SectionContainer,
	Section,
	CtaWrapper,
	TagSection,
} from "./style";
import { Modal, CtaButton } from "../../../Elements";
import CareerTrackOption from "./CareerTrackOption";
import { CloudinaryImage } from "@website-builder/ui/shared/elements";

const CareerTracksModal = (props) => {
	const {
		show,
		careerTracks,
		careerAssessmentTestLink,
		handleModalClose,
		exploreCareerpathsHeader,
	} = props;

	return (
		<ModalContainer>
			<Modal
				show={show}
				onClose={handleModalClose}
				disableBackdropClick={true}
				className="modal"
			>
				<CareerTrackModalWrapper>
					{exploreCareerpathsHeader && (
						<ModalHeading>{exploreCareerpathsHeader}</ModalHeading>
					)}
					<div className="modalDropdownView">
						{careerTracks.map((careerTrack, index) => (
							<CareerTrackOption key={index} careerTrack={careerTrack} />
						))}
					</div>
					<CardsWrapper>
						{careerTracks.map((careerTrack, index) => (
							<CourseCard key={index}>
								<CardContainer>
									<CardHeader>
										<CloudinaryImage
											url={careerTrack?.image?.image}
											sizes={{
												default: {
													height: 200,
												},
											}}
											lazyload
										/>
										<Heading>{careerTrack?.header}</Heading>
										<Content>{careerTrack?.description}</Content>
									</CardHeader>
									<SectionContainer>
										{careerTrack?.section.map((section, index) => (
											<Section key={index}>
												<p className="sectionHeading">{section?.title}</p>
												<p className="sectionDescription">
													{section?.description}
												</p>
											</Section>
										))}
									</SectionContainer>
									<CtaWrapper>
										<CtaButton
											cta={{
												type: careerTrack?.cta[0]?.type,
												text: careerTrack?.cta[0]?.text,
												link: {
													target: careerTrack?.cta[0]?.link?.target,
													type: careerTrack?.cta[0]?.link?.type,
													value: careerTrack?.cta[0]?.link?.link,
												},
											}}
											className="careerTrackCta"
										/>
									</CtaWrapper>
								</CardContainer>
							</CourseCard>
						))}
						{careerAssessmentTestLink && (
							<TagSection>
								<p>Not sure where to start?</p>
								<a href={careerAssessmentTestLink.value}>
									Take our career assessment test
								</a>
							</TagSection>
						)}
					</CardsWrapper>
				</CareerTrackModalWrapper>
			</Modal>
		</ModalContainer>
	);
};

export const LinkType = Proptypes.shape({
	value: Proptypes.string,
	type: Proptypes.oneOf(["internal", "external", "hash"]),
});

export const CareerTrackWithCta = Proptypes.shape({
	header: Proptypes.string,
	description: Proptypes.string,
	image: Proptypes.shape({
		image: Proptypes.string,
		altTag: Proptypes.string,
	}),
	cta: Proptypes.arrayOf(
		Proptypes.shape({
			buttonText: Proptypes.string,
			type: Proptypes.string,
			link: Proptypes.shape({
				enable: Proptypes.bool,
				link: Proptypes.string,
				target: Proptypes.string,
				type: Proptypes.string,
			}),
			color: Proptypes.string,
		}),
	),
	section: Proptypes.arrayOf(
		Proptypes.shape({
			title: Proptypes.string,
			description: Proptypes.string,
		}),
	),
});

CareerTracksModal.propTypes = {
	show: Proptypes.bool,
	careerTracks: Proptypes.arrayOf(CareerTrackWithCta),
	careerAssessmentTestLink: LinkType,
	handleModalClose: Proptypes.func,
	exploreCareerpathsHeader: Proptypes.string,
};

CareerTracksModal.defaultProps = {
	show: false,
	careerTracks: [],
	careerAssessmentTestLink: null,
	handleModalClose: () => {},
	exploreCareerpathsHeader: "",
};

export default CareerTracksModal;
